import { usePortalSize } from "@src/Components/Common/usePortalSize"
import Tooltip from "@src/Components/Tooltip"
import { colors } from "@src/theme"
import { Button, Typography } from "@zeguro/component-library"
import * as React from "react"

import { Section } from "../StyledUtils"
import {
  ButtonContainer,
  CardIcon,
  IconButton,
  IconGroup,
  PageHeaderContainer,
  Vr,
} from "./styles"

interface IPageHeader {
  heading?: string | JSX.Element
  infoText?: string | JSX.Element
  showButton?: boolean
  onClickButton?: () => void
  buttonType?: "primary" | "secondary"
  buttonText?: string
  buttonWidth?: number
  showHelpCenter?: boolean
  helpCenterLinkUrl?: string
  showViewIntro?: boolean
  onClickViewIntro?: () => void
  id?: string
  color?: string
  cardIconUrl?: string
}

export const PageHeader = (props: IPageHeader) => {
  const {
    onClickViewIntro,
    helpCenterLinkUrl,
    showButton,
    onClickButton,
    buttonWidth,
    buttonText,
    buttonType,
    id,
    showViewIntro,
    showHelpCenter,
    heading,
    infoText,
    color,
    cardIconUrl,
  } = props
  const { isDesktop } = usePortalSize()

  return (
    <PageHeaderContainer>
      {isDesktop && (
        <Typography
          variant="heading1"
          id={id}
          color={color || colors.darkBlue}
          lineHeight="1.6"
        >
          {heading || ""}
          {infoText && (
            <Section
              fontSize="15px"
              fontWeight="400"
              fontColor={colors.gray40}
              padding="10 0 0"
            >
              {infoText}
            </Section>
          )}
        </Typography>
      )}
      <div>
        {!isDesktop && <CardIcon src={cardIconUrl} />}
        {isDesktop && (
          <ButtonContainer>
            <Button
              hidden={!showButton || (buttonType && buttonType !== "primary")}
              width={buttonWidth ? `${buttonWidth}px` : "115px"}
              onClick={onClickButton}
              variant="primary"
            >
              {buttonText}
            </Button>
            <Button
              hidden={!showButton || buttonType !== "secondary"}
              width={buttonWidth ? `${buttonWidth}px` : "115px"}
              onClick={onClickButton}
              variant="secondary"
            >
              {buttonText}
            </Button>
            {showViewIntro &&
              onClickViewIntro &&
              showHelpCenter &&
              helpCenterLinkUrl && (
                <IconGroup>
                  <Tooltip
                    id="view-intro-tooltip"
                    content={<p>View Intro</p>}
                  />
                  <IconButton
                    variant="tertiary"
                    onClick={onClickViewIntro}
                    data-tooltip-id="view-intro-tooltip"
                    aria-label="View Intro"
                    height="40px"
                    padding="0 13px"
                  >
                    <img src="images/icon_view_intro.svg" />
                  </IconButton>
                  <Vr />
                  <Tooltip
                    id="help-center-tooltip"
                    content={<p>Help Center</p>}
                    place="top"
                  />
                  <IconButton
                    variant="tertiary"
                    onClick={(e) => {
                      e.stopPropagation()
                      window.open(helpCenterLinkUrl)
                    }}
                    data-tooltip-id="help-center-tooltip"
                    aria-label="Help Center"
                    height="40px"
                    padding="0 13px"
                  >
                    <img src="images/icon_knowledge_base_info_help.svg" />
                  </IconButton>
                </IconGroup>
              )}
          </ButtonContainer>
        )}
      </div>
      {!isDesktop && (
        <Section flex="flex-start flex-start column">
          <Typography variant="heading1" id={id} color={color}>
            {heading || ""}
          </Typography>
          {infoText && (
            <Section fontSize="15px" fontColor={colors.gray40} padding="6 0 0">
              {infoText}
            </Section>
          )}
        </Section>
      )}
    </PageHeaderContainer>
  )
}
export default PageHeader
